/* unplugin-vue-components disabled */import { render } from "./settings.vue?vue&type=template&id=f5e9f98a&scoped=true"
import script from "./settings.vue?vue&type=script&setup=true&lang=js"
export * from "./settings.vue?vue&type=script&setup=true&lang=js"

import "./settings.vue?vue&type=style&index=0&id=f5e9f98a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e9f98a"],['__file',"src/pages/settings/settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5e9f98a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5e9f98a', __exports__)) {
    api.reload('f5e9f98a', __exports__)
  }
  
  module.hot.accept("./settings.vue?vue&type=template&id=f5e9f98a&scoped=true", () => {
    api.rerender('f5e9f98a', render)
  })

}


export default __exports__